import jwtDecode from 'jwt-decode';
import { UserSettingsConfiguration } from '../../models/userSettingConfiguration';
import { httpService } from '../httpService';

export interface LoginData {
  username: string;
  password: string;
}

interface LoginResponse {
  token: string;
  userDetails: UserSettingsConfiguration;
}

export const processToken = (token: string): LoginResponse => {
  const decryptedToken = jwtDecode<UserSettingsConfiguration>(token);
  
  return { token, userDetails: decryptedToken };
};

// Keep for backward compatibility if needed
export const login = async (loginData: LoginData): Promise<LoginResponse> => {
  const response = await httpService.post<LoginData, string>(
    '/api/Auth',
    loginData
  );
  
  return processToken(response.data);
};

export const logout = async (accessToken: string): Promise<void> => {
  try {
    await httpService.post('/api/Auth/Logout', accessToken);
  } catch (err) {
    console.error(err);
  }
};

export const refreshToken = async (accessToken: string): Promise<unknown> => {
  const response = await httpService.post<string, string>(
    '/api/Auth/RefreshToken',
    accessToken
  );
  
  return response;
};
